module.exports = __webpack_public_path__ + "static/img/img.aba24b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yanzi/img.png
// module id = S0rV
// module chunks = 1